module.exports = __webpack_public_path__ + "static/media/globepc.07119f49.jpg";